import ReactIs from "react-is";

export default ReactIs;
export * from "react-is/cjs/react-is.production.min.js";
export const __esModule = true;
